import { render, staticRenderFns } from "./DotsItem.vue?vue&type=template&id=05011139&scoped=true"
import script from "./DotsItem.vue?vue&type=script&lang=js"
export * from "./DotsItem.vue?vue&type=script&lang=js"
import style0 from "./DotsItem.vue?vue&type=style&index=0&id=05011139&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05011139",
  null
  
)

export default component.exports